import { ReactNode } from 'react'
import { Info, AlertTriangle, Lightbulb } from 'lucide-react'

type BannerVariant = 'info' | 'warning' | 'tip'

interface InfoBannerProps {
  children: ReactNode
  variant?: BannerVariant
  className?: string
}

const variantStyles: Record<BannerVariant, {
  container: string
  icon: string
  Icon: typeof Info
}> = {
  info: {
    container: 'bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800 text-blue-700 dark:text-blue-300',
    icon: 'text-blue-500 dark:text-blue-400',
    Icon: Info,
  },
  warning: {
    container: 'bg-amber-50 dark:bg-amber-900/20 border-amber-200 dark:border-amber-800 text-amber-700 dark:text-amber-300',
    icon: 'text-amber-500 dark:text-amber-400',
    Icon: AlertTriangle,
  },
  tip: {
    container: 'bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-800 text-green-700 dark:text-green-300',
    icon: 'text-green-500 dark:text-green-400',
    Icon: Lightbulb,
  },
}

export function InfoBanner({
  children,
  variant = 'info',
  className = ''
}: InfoBannerProps) {
  const styles = variantStyles[variant]
  const { Icon } = styles

  return (
    <div
      className={`
        flex items-start gap-2 p-3 border rounded-lg text-sm
        ${styles.container}
        ${className}
      `}
    >
      <Icon className={`h-4 w-4 flex-shrink-0 mt-0.5 ${styles.icon}`} />
      <div>{children}</div>
    </div>
  )
}
